import script from "./IconButton.vue?vue&type=script&setup=true&lang=js"
export * from "./IconButton.vue?vue&type=script&setup=true&lang=js"

import "./IconButton.vue?vue&type=style&index=0&id=a8f78ec2&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8f78ec2"]])

export default __exports__